import React from 'react';
import { gql, useQuery } from '@apollo/client';

// Data
import { useRecordPlayerEdit } from '../../../lib/services/player-session.service';
import { buildFieldsAction } from '../../../lib/helpers/player-action.helper';
import { PLAYER_FIELDS } from '../../../lib/queries/player.queries';

// Components
import { EditPlayerContainer } from './edit-player.container';
import { IEditPlayerProps } from './edit-player.interface';
import { PLAYER_ASSESSMENT_FIELDS } from '../../../lib/queries/player-assessment.queries';

const GET_EDIT_PLAYER = gql`
  query GetEditPlayer($playerAssessmentId: ID!) {
    playerAssessment(_id: $playerAssessmentId) {
      ...PlayerAssessmentFields
    }
  }

  ${PLAYER_ASSESSMENT_FIELDS}
`;

interface IEditPlayerGraphQL {
  hasConfigRole?: boolean;
  playerId: string;
  playerAssessmentId: string;
}

const EditPlayerGraphQL: React.FC<IEditPlayerGraphQL> = ({ hasConfigRole, playerId, playerAssessmentId }) => {
  const { data, loading, error } = useQuery(GET_EDIT_PLAYER, {
    variables: { playerAssessmentId },
    fetchPolicy: 'cache-and-network'
  });

  const player = data && data.playerAssessment.player;

  const recordPlayerEdit = useRecordPlayerEdit(['GetEditPlayer']);

  const updatePlayerMutation = (data: IEditPlayerProps) =>
    recordPlayerEdit(buildFieldsAction(playerId, playerAssessmentId, data as unknown as Record<string, unknown>), {
      authoritative: true,
      optimisticUpdate: (cache) => {
        const id = cache.identify({ __typename: 'Player', _id: playerId });
        const prev = cache.readFragment({ id, fragment: PLAYER_FIELDS });
        cache.writeFragment({ id, fragment: PLAYER_FIELDS, data: { __typename: 'Player', _id: playerId, ...data } });
        return () => cache.writeFragment({ id, fragment: PLAYER_FIELDS, data: prev });
      },
    });

  return <EditPlayerContainer
    hasConfigRole={hasConfigRole}
    player={player}
    updatePlayerMutation={updatePlayerMutation}
    loading={loading}
    fetchError={Boolean(error)}
  />;
};

export { EditPlayerGraphQL };
